{
  "auth": {
    "invalidCredentials": "El correo o la contraseña son incorrectos. Si cambiaste tu contraseña, usa la nueva.",
    "emailNotConfirmed": "Revisa tu bandeja de entrada y haz clic en el enlace de confirmación antes de iniciar sesión.",
    "passwordsDontMatch": "Las contraseñas no coinciden. Inténtalo de nuevo.",
    "passwordTooShort": "La contraseña debe tener al menos 6 caracteres.",
    "invalidEmail": "El correo electrónico no tiene un formato válido.",
    "disposableEmail": "No se permiten correos temporales. Usa un correo real.",
    "recaptchaFailed": "Verificación de seguridad fallida. Inténtalo de nuevo.",
    "emailAlreadyInUse": "Este correo electrónico ya está registrado.",
    "registerSuccess": "¡Cuenta creada! Revisa tu correo para confirmarla.",
    "loginSuccess": "¡Sesión iniciada correctamente!",
    "emailNotConfirmedTitle": "Correo no confirmado",
    "invalidCredentialsTitle": "Credenciales inválidas",
    "loggingIn": "Iniciando...",
    "creatingAccount": "Creando cuenta...",
    "fillCredentials": "Introduce tu correo y contraseña."
  },
  "events": {
    "foodRain": "Lluvia de Comida",
    "meteorShower": "Lluvia de Meteoritos",
    "poisonZone": "Zona de Veneno",
    "gravityWell": "Imán Gravitatorio",
    "warning": "{{name}} en {{seconds}}s",
    "nextEvent": "PRÓXIMO EVENTO",
    "nextDanger": "PRÓXIMO PELIGRO"
  },
  "hud": {
    "mass": "Masa",
    "kills": "Asesinatos",
    "deaths": "Muertes",
    "players": "Jugadores",
    "bots": "Bots",
    "ranking": "Ranking",
    "top5": "TOP 5",
    "streak": "Racha",
    "profile": "PERFIL",
    "help": "AYUDA",
    "hunts": "Cazas:",
    "fleesFrom": "Huye de:",
    "you": "TÚ",
    "none": "NINGUNO",
    "spectatorBadge": "MODO ESPECTADOR",
    "observingArena": "Observando la arena",
    "observingTarget": "Observando a {{alias}} ({{mass}} masa)",
    "playNow": "JUGAR AHORA"
  },
  "combat": {
    "combo": "Combo x{{count}}",
    "comboText": "⚡ COMBO x{{count}}!",
    "massBonus": "+{{count}} MASA",
    "killstreak": "Racha: {{count}}",
    "dominating": "DOMINANDO",
    "unstoppable": "IMPARABLE",
    "bloodthirsty": "SEDIENTO DE ALQUIMIA",
    "alchemyGod": "DIOS ALQUIMISTA",
    "shutdown": "CAZARRECOMPENSAS",
    "shutdownTitle": "🎯 CAZARRECOMPENSAS!",
    "shutdownDesc": "{{killer}} frenó a {{victim}} (+{{bounty}})",
    "respawningIn": "Reapareciendo en {{seconds}}s..."
  },
  "powerups": {
    "speed": "Velocidad",
    "doubleMass": "Doble Masa",
    "shield": "Escudo",
    "invulnerability": "Invulnerabilidad",
    "freeze": "Congelar",
    "speedTitle": "Súper Velocidad (20s)",
    "speedBonus": "+50% masa inicial (150)",
    "doubleMassTitle": "Súper Absorción (25s)",
    "doubleMassBonus": "+50% masa inicial (150)",
    "tripleShieldTitle": "Triple Escudo (3 impactos)",
    "tripleShieldBonus": "+50% masa inicial (150)",
    "invulnerabilityTitle": "Inmunidad Total (12s)",
    "invulnerabilityBonus": "+50% masa inicial (150)",
    "healingTitle": "Regeneración Instantánea",
    "healingBonus": "+150% masa inicial (250)"
  },
  "elements": {
    "fire": "Fuego",
    "water": "Agua",
    "plant": "Planta",
    "electric": "Eléctrico",
    "earth": "Tierra"
  },
  "skins": {
    "default": "Defecto",
    "ring": "Anillo",
    "dotted": "Punteado",
    "metallic": "Metálico",
    "eyes": "Ojos",
    "smile": "Sonrisa"
  },
  "tutorial": {
    "welcome": "Bienvenido a Alchem.io",
    "step1": "Muévete con el ratón o táctil",
    "step2": "Come bolitas de color para crecer",
    "step3": "Usa counters para castigar a jugadores más grandes",
    "step4": "Sobrevive y sube en el ranking",
    "stepLabel": "PASO {{current}}/{{total}}",
    "identity": "Eres tu elemento. Cazas y huyes según los counters.",
    "movement": "Mueve el ratón o joystick para desplazarte por la arena.",
    "growth": "Absorbe orbes de energía para crecer ({{count}}/3).",
    "danger": "¡Cuidado! Un rival de tu counter está cerca. Mantén distancia.",
    "skip": "Saltar tutorial"
  },
  "modals": {
    "play": "Jugar",
    "spectate": "Espectar",
    "revive": "Revivir",
    "profile": "Perfil",
    "help": "Ayuda",
    "close": "Cerrar",
    "enterArena": "⚔️ ENTRAR A LA ARENA",
    "enterAsSpectator": "👁️ MODO ESPECTADOR",
    "chooseIdentity": "FORJA TU IDENTIDAD",
    "chooseSkin": "Elige tu skin:",
    "aliasPlaceholder": "Tu alias (máx 12)",
    "showTutorial": "Mostrar tutorial la primera vez",
    "anonHint": "Si lo dejas vacío jugarás como AnonXXX",
    "youHaveBeenDevoured": "HAS SIDO DEVORADO",
    "reviveFree": "Revivir ya (gratis)",
    "reviveFreeSub": "Respawn normal sin espera ni anuncios",
    "respawnAction": "Reaparecer →",
    "staySpectator": "Quedarme como espectador",
    "staySpectatorSub": "Observa la partida en vivo y entra cuando quieras",
    "watchAction": "Observar →",
    "watchAdBonus": "O VUELVE MÁS FUERTE CON BONIFICACIÓN",
    "watchAdTag": "🎁 VER ANUNCIO (~15s)",
    "adCooldown": "⏳ Recompensas con anuncio disponibles en {{timer}}",
    "confirmChangeAlias": "¿Seguro que quieres cambiar de alias? Se te pedirá uno nuevo.",
    "confirmResetProgress": "¿Seguro que deseas reiniciar tu progreso? Se perderán todas tus estadísticas locales.",
    "profileTitle": "PERFIL DEL ALQUIMISTA",
    "changeAlias": "Cambiar alias",
    "resetProgress": "Borrar progreso",
    "profileCloseHint": "Pulsa [P] o [ESC] para cerrar"
  },
  "misc": {
    "loading": "Cargando...",
    "connecting": "Conectando...",
    "disconnected": "Desconectado",
    "connectionError": "Error de conexión. Recarga la página.",
    "spawnGreeting": "Eres {{element}}",
    "spawnHint": "Mueve el ratón o pulsa una tecla para empezar"
  },
  "quests": {
    "title": "MISIONES Y LOGROS",
    "dailyTab": "Misiones Diarias",
    "achievementsTab": "Logros Alquímicos",
    "resetIn": "Reinicio en:",
    "claim": "Reclamar",
    "claimed": "Reclamado",
    "completed": "¡Completado!",
    "astralChanneling": "Canalización Astral",
    "watchAd": "Ver Anuncio (+2 🔮, +50 💎)",
    "adsRemaining": "{{remaining}}/3 restantes hoy",
    "noAdsLeft": "Límite diario alcanzado (3/3)",
    "adSuccess": "¡Canalización exitosa! Has recibido 2 🔮 y 50 💎",
    "adError": "No se pudo completar el anuncio. Inténtalo más tarde.",
    "rewardClaimed": "¡Recompensa reclamada!",
    "rewardClaimedDesc": "+{{crystals}} 💎 y +{{orbs}} 🔮",
    "loginStreak": "Racha: {{days}} días",
    "kill_players": "Elimina a 3 jugadores",
    "eat_orbs": "Consume 400 nutrientes alquímicos",
    "drain_mass_counter": "Drena 1,500 de masa con counters",
    "reach_mass": "Alcanza 2,500 de masa",
    "survive_time": "Sobrevive 4 minutos en una vida",
    "collect_powerups": "Recoge 3 power-ups",
    "desc_kill_players": "Devora a 3 rivales en la arena alquímica.",
    "desc_eat_orbs": "Absorbe orbes de masa dispersos en el mapa.",
    "desc_drain_mass_counter": "Golpea a rivales aprovechando counters elementales.",
    "desc_reach_mass": "Crece y mantente con vida hasta superar los 2,500 de masa.",
    "desc_survive_time": "Mantente con vida continuamente durante 240 segundos.",
    "desc_collect_powerups": "Encuentra y recoge potenciadores en la arena."
  },
  "achievements": {
    "login_streak_5": "Inicia sesión 5 días seguidos",
    "reach_titan_8k": "Alcanza 8,000 de masa",
    "kill_with_all_elements": "Logra 1 kill con cada elemento",
    "shutdown_bounty": "Neutraliza a 3 rivales en racha",
    "desc_login_streak_5": "Demuestra tu constancia ingresando a Alchem.io 5 días consecutivos.",
    "desc_reach_titan_8k": "Conviértete en un titán alcanzando la masa de 8,000.",
    "desc_kill_with_all_elements": "Domina los 5 elementos logrando al menos 1 kill con cada uno.",
    "desc_shutdown_bounty": "Pon fin a la racha de al menos 3 rivales en racha asesina (Shutdown)."
  }
}

